import styled from 'styled-components/macro';
import { css } from 'styled-transition-group';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { Row } from '@yme/atoms/grid';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { HEADER_HEIGHT } from '@yme/common/constants';
import { SubMenuWrapperStyled } from '@yme/components/Header/Megamenu/styled';
import { Link } from '@yme/components/Link';
import { SlideFwdCenter } from '@yme/tokens/animations';
import { colorBlackTransparent300, colorBrandYamahaRed, colorCoreBackground1000, colorCoreBlack1000, colorCoreBlack900Base, colorCoreGray100, colorCoreGray200, colorCoreGray500, colorCoreWhite1000, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
import { MAX_HEIGHT_MENU } from './constants';
const getMenuIndent = (isTouchDevice) => (isTouchDevice ? INDENT.sm : INDENT.xl);
export const OverlayStyled = styled.div `
  position: absolute;
  top: calc(100% + 1px);
  left: 50%;
  width: 100vw;
  height: 100vh;

  z-index: ${Z_INDEX.level3};
  transform: translateX(-50%);

  ${SlideFwdCenter};
`;
export const StickyWrapperStyled = styled.div `
  box-sizing: border-box;
  position: static;
  top: ${({ heightOfMenu }) => `-${heightOfMenu}px`};
  background-color: ${colorCoreGray100};
  border-bottom: 1px solid ${colorCoreGray500};
  transition: top 0.5s;

  ${({ isSticky }) => isSticky &&
    css `
      position: fixed;
      top: 0;
      z-index: ${Z_INDEX.popupLevel1};
      width: 100%;
      box-sizing: border-box;
    `}
`;
export const HeaderStyled = styled.div `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: stretch;

  z-index: ${Z_INDEX.popupLevel1};

  min-height: ${HEADER_HEIGHT.sm};

  ${ADAPTIVE.minWidth.tablet} {
    min-height: ${HEADER_HEIGHT.md};
  }

  ${ADAPTIVE.minWidth.desktop} {
    min-height: ${HEADER_HEIGHT.lg};
  }

  /* TODO: temporary solution. Ned remove after implement common LTR-feature */
  direction: ${({ isRightToLeft }) => (isRightToLeft ? 'rtl' : 'ltr')};

  /* TODO: Move this trick into global styles (+ Need Improve options) */
  span {
    direction: ltr;
  }
`;
export const HeaderWithSearchStyled = styled(Row) `
  position: relative;
  align-items: center;

  background-color: ${colorCoreWhite1000};

  z-index: ${Z_INDEX.popupLevel1};

  min-height: ${HEADER_HEIGHT.sm};

  ${ADAPTIVE.minWidth.tablet} {
    min-height: ${HEADER_HEIGHT.md};
  }

  ${ADAPTIVE.minWidth.desktop} {
    min-height: ${HEADER_HEIGHT.lg};
  }
`;
export const HeaderContainerStyled = styled.div `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: ${colorCoreGray100};
  z-index: ${Z_INDEX.level2};
`;
export const ProfileContainerStyled = styled.div `
  ${({ isRightToLeft }) => (isRightToLeft ? 'margin-right: auto' : 'margin-left: auto')};
`;
export const SplitterStyled = styled.div `
  background-color: ${colorBlackTransparent300};
  border-radius: ${CORNER_RADIUS.xxs};

  width: 2px;
  display: inline-flex;
  height: 20px;
  padding: 3px 0;
  margin: 0 11px;
  box-sizing: border-box;
`;
export const LogoSplitterStyled = styled(SplitterStyled) `
  margin: 0 18px;
`;
export const MegamenuStyled = styled.div `
  position: relative;
  width: ${({ isProductMenu }) => (isProductMenu ? '366px' : '100%')};
  min-height: 420px;

  @media only screen and (max-height: 540px) {
    min-height: 290px;
  }

  ${({ isProductMenu, isRightToLeft }) => isProductMenu
    ? css `
          width: 366px;
          background-color: ${colorCoreGray100};

          ${isRightToLeft
        ? `border-left: 1px solid ${colorCoreGray500}`
        : `border-right: 1px solid ${colorCoreGray500}`};

          ${ADAPTIVE.maxWidth.desktop} {
            width: 260px;
          }
        `
    : css `
          width: 100%;
          background-color: ${colorCoreGray200};

          ${ADAPTIVE.maxWidth.desktop} {
            min-height: 343px;
          }

          ${ADAPTIVE.maxWidth.tablet} {
            min-height: auto;
          }
        `};

  ${ADAPTIVE.maxWidth.desktop} {
    width: ${({ isProductMenu }) => (isProductMenu ? '260px' : '100%')};
  }
`;
export const MegamenuListStyled = styled.ul `
  margin: 0;
  height: 100%;

  ${CustomScroll};

  max-height: 560px;
  padding: 0;
  border: none;
  border-bottom: 6px solid transparent;

  @media only screen and (max-height: ${MAX_HEIGHT_MENU}) {
    max-height: calc(100vh - (${HEADER_HEIGHT.lg} + ${INDENT.xl}));
  }

  li {
    word-break: break-word;
  }

  @media (hover: hover) {
    li:hover > ${SubMenuWrapperStyled} {
      visibility: visible;
      opacity: 1;
      transition: opacity 0.3s, visibility 0s;
    }

    li:not(:hover) > ${SubMenuWrapperStyled} {
      transition-delay: 0.5s;
    }

    li:hover
      ${SubMenuWrapperStyled}
      li
      ${SubMenuWrapperStyled},
      li:hover
      ${SubMenuWrapperStyled}
      li:hover
      ${SubMenuWrapperStyled}
      li
      ${SubMenuWrapperStyled} {
      visibility: hidden;
    }

    li:hover ul > li {
      color: ${colorCoreBlack900Base};
    }

    li:hover ul > li:hover {
      color: ${colorBrandYamahaRed};
    }

    li:hover
      ${SubMenuWrapperStyled}
      li:hover
      ${SubMenuWrapperStyled},
      li:hover
      ${SubMenuWrapperStyled}
      li:hover
      ${SubMenuWrapperStyled}
      li:hover
      ${SubMenuWrapperStyled} {
      visibility: visible;
      opacity: 1;
      transition: opacity 0.3s, visibility 0s;
      transition-delay: 0.5s;
    }

    li:hover
      ${SubMenuWrapperStyled}
      li:not(:hover)
      ${SubMenuWrapperStyled},
      li:hover
      ${SubMenuWrapperStyled}
      li:hover
      ${SubMenuWrapperStyled}
      li:not(:hover)
      ${SubMenuWrapperStyled} {
      transition-delay: 0.5s;
    }

    li ul li:hover ul li {
      color: ${colorCoreBlack900Base};
    }
  }

  & > li ${SubMenuWrapperStyled} {
    ${({ isRightToLeft }) => isRightToLeft ? 'transform: translateX(-100%)' : 'transform: translateX(100%)'};
  }
`;
export const ListTitleStyled = styled.span `
  display: block;
  min-height: 20px;
  margin-bottom: ${INDENT.xs};
  padding-bottom: ${INDENT.xxxs};
  border-bottom: 1px solid ${colorCoreGray500};
  color: ${({ isMenuStandoutColourEnabled }) => isMenuStandoutColourEnabled ? colorBrandYamahaRed : colorCoreBlack1000};

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${getTextStyles('Play', 700, 14, 20)}

  text-transform: uppercase;

  ${ADAPTIVE.minWidth.desktop} {
    margin: ${({ isTouchDevice, isRightToLeft }) => isRightToLeft
    ? `0 ${getMenuIndent(isTouchDevice)} 10px 0`
    : `0 0 10px ${getMenuIndent(isTouchDevice)}`};
    padding-bottom: 18px;
  }
`;
export const LinkStyled = styled(Link) `
  display: flex;
  align-items: center;
  text-decoration: none;
`;
export const IconStyled = styled(SVGIcon) `
  margin-right: ${INDENT.xxxxs};
`;
export const LinkWrapperStyled = styled.p `
  margin: 0;
  padding-top: 14px;

  ${({ isInSubMenu }) => isInSubMenu &&
    css `
      margin-top: auto;
      padding: 14px 20px;
      border-top: 1px solid ${colorCoreGray500};
      background-color: ${colorCoreBackground1000};
    `}

  ${ADAPTIVE.minWidth.desktop} {
    margin-top: auto;
    ${({ isTouchDevice = false, isRightToLeft }) => isRightToLeft
    ? `margin-right: ${getMenuIndent(isTouchDevice)}`
    : `margin-left: ${getMenuIndent(isTouchDevice)}`};
    border-top: 1px solid ${colorCoreGray500};

    ${({ isInSubMenu }) => isInSubMenu &&
    css `
        margin: ${({ isTouchDevice = false }) => (isTouchDevice ? 'auto 0 0 0' : '0')};
        padding: 15px 12px;
      `}
  }

  ${LinkStyled} {
    ${getTextStyles('Ubuntu', 700, 14, 20)}

    color: ${colorCoreBlack900Base};
  }
`;
const hoverStyles = (isLink) => isLink
    ? css `
        a {
          text-decoration: underline;
        }
      `
    : css `
        > span {
          svg {
            path {
              stroke: ${colorBrandYamahaRed};
            }
          }
        }
        color: ${colorBrandYamahaRed};
      `;
export const MegamenuListItemStyled = styled.li `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${({ isRightToLeft }) => isRightToLeft ? `0 ${INDENT.xl} 0 6px` : `0 6px 0 ${INDENT.xl}`};
  gap: 4px;
  cursor: pointer;

  ${({ isSmallItem }) => isSmallItem
    ? css `
          &:not(:last-child) {
            margin-bottom: 16px;
          }
        `
    : css `
          min-height: 56px;
        `};

  border-radius: ${CORNER_RADIUS.none};
  color: ${colorCoreBlack900Base};
  direction: ${({ isRightToLeft }) => (isRightToLeft ? 'rtl' : 'ltr')};

  -webkit-tap-highlight-color: transparent;

  ${ADAPTIVE.minWidth.desktop} {
    ${({ isRightToLeft }) => (isRightToLeft ? 'padding-left: 16px' : 'padding-right: 16px')};

    ${({ isSmallItem }) => isSmallItem &&
    css `
        padding-top: 5px;
        padding-bottom: 5px;
        &:not(:last-child) {
          margin-bottom: 4px;
        }
      `};
  }

  a {
    ${getTextStyles('Ubuntu', 400, 14, 20)}

    color: inherit;
    text-decoration: none;
    text-transform: none;
  }

  span {
    ${getTextStyles('Play', 700, 14, 16)}

    display: flex;
    align-items: center;
    letter-spacing: 0.02em;
    text-transform: uppercase;

    &:active {
      ${({ isLink = false }) => hoverStyles(isLink)}
    }
  }

  @media (hover: hover) {
    &:hover {
      ${({ isLink = false }) => hoverStyles(isLink)}
    }
  }
`;
export const ListWrapperStyled = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;

  ${ADAPTIVE.minWidth.desktop} {
    width: auto;

    ${({ isWidthAuto }) => !isWidthAuto &&
    css `
        width: 260px;
        min-width: 260px;
      `};
  }

  ${MegamenuListStyled} {
    ${ADAPTIVE.minWidth.desktop} {
      height: ${({ isFullHeight }) => (isFullHeight ? '244px' : '205px')};
      padding: ${({ isRightToLeft }) => (isRightToLeft ? '0 0 0 8px' : '0 8px 0 0')};
    }

    ${ADAPTIVE.minWidth.desktopLg} {
      height: ${({ isFullHeight }) => (isFullHeight ? '317px' : '278px')};
    }
  }

  ${MegamenuListItemStyled} {
    padding: 0;

    ${ADAPTIVE.minWidth.desktop} {
      padding: ${({ isTouchDevice, isRightToLeft }) => isRightToLeft
    ? ` 5px ${getMenuIndent(isTouchDevice)} 5px 0`
    : `5px 0 5px ${getMenuIndent(isTouchDevice)}`};
    }
  }

  ${({ isWidthAuto }) => isWidthAuto &&
    css `
      ${MegamenuListItemStyled} {
        ${ADAPTIVE.minWidth.desktop} {
          padding: 5px 0 5px 0;
        }
      }

      ${LinkWrapperStyled} {
        margin: 0;
      }

      ${ListTitleStyled} {
        margin-left: 0;
        margin-right: 0;
      }
    `};
`;
export const MegaMenuColStyled = styled.div `
  width: 100%;
  padding-bottom: 28px;

  ${ADAPTIVE.minWidth.tablet} {
    width: calc(100% / 2 - ${INDENT.xxs});

    &:not(:nth-child(${({ isRightToLeft }) => (isRightToLeft ? 'odd' : 'even')})) {
      margin-right: ${INDENT.sm};
    }
  }

  ${ADAPTIVE.minWidth.desktop} {
    width: calc(100% / 7);
    padding: 0;

    &:not(:${({ isRightToLeft }) => (isRightToLeft ? 'first-child' : 'last-child')}) {
      margin-right: ${INDENT.sm};
    }

    &: ${({ isRightToLeft }) => (isRightToLeft ? 'last-child' : 'first-child')} {
      margin-left: ${({ isTouchDevice }) => getMenuIndent(isTouchDevice)};
    }

    &: ${({ isRightToLeft }) => (isRightToLeft ? 'first-child' : 'last-child')} {
      margin-right: ${INDENT.xl};
    }
  }

  ${MegamenuListStyled} {
    ${ADAPTIVE.minWidth.desktop} {
      height: 284px;
    }
  }
`;
export const BackButtonStyled = styled.div `
  ${getTextStyles('Play', 700, 14, 16)}

  display: flex;
  align-items: center;
  text-transform: uppercase;
  cursor: pointer;
  letter-spacing: 0.02em;

  color: ${colorCoreBlack900Base};

  & > span:first-child {
    ${({ isRightToLeft }) => !isRightToLeft && 'transform: rotate(180deg);'}
  }

  & > span:last-child {
    padding: 10px 5px;
  }
`;
export const HeaderLogoWrapper = styled.div `
  ${ADAPTIVE.minWidth.desktopLg} {
    ${({ isRightToLeft }) => isRightToLeft ? `margin-left: ${INDENT.xs}` : `margin-right: ${INDENT.xs}`};
  }
`;
